"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Alliance',
  data: function data() {
    return {
      ruleForm: {
        androidAppKey: '',
        iosAppKey: ''
      },
      rules: {
        androidAppKey: [{
          required: true,
          message: '请输入安卓  AppKey',
          trigger: 'blur'
        }],
        iosAppKey: [{
          required: true,
          message: '请输入ios  AppKey',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.queryThirdConfig();
  },
  methods: {
    queryThirdConfig: function () {
      var _queryThirdConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                type: 0
              };
              _context.n = 1;
              return (0, _threePartyConfiguration.queryThirdConfig)(params);
            case 1:
              res = _context.v;
              console.log('res', res);
              if (res.code === 0 && res.data.umengConfig) {
                this.ruleForm.androidAppKey = res.data.umengConfig.androidAppKey;
                this.ruleForm.iosAppKey = res.data.umengConfig.iosAppKey;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function queryThirdConfig() {
        return _queryThirdConfig2.apply(this, arguments);
      }
      return queryThirdConfig;
    }(),
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认修改此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.thirdConfig();
          });
        } else {
          return false;
        }
      });
    },
    thirdConfig: function () {
      var _thirdConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                type: 0,
                umengConfig: (0, _objectSpread2.default)({}, this.ruleForm)
              };
              _context2.n = 1;
              return (0, _threePartyConfiguration.thirdConfig)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.queryThirdConfig();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function thirdConfig() {
        return _thirdConfig2.apply(this, arguments);
      }
      return thirdConfig;
    }()
  }
};